export const RefineButtonTestIds = {
  CloneButton: "refine-clone-button",
  DeleteButton: "refine-delete-button",
  EditButton: "refine-edit-button",
  SaveButton: "refine-save-button",
  CreateButton: "refine-create-button",
  ImportButton: "refine-import-button",
  ExportButton: "refine-export-button",
  ListButton: "refine-list-button",
  RefreshButton: "refine-refresh-button",
  ShowButton: "refine-show-button",
};
